export const featureFlagsIdentityManagement:Record<string, boolean> = {
  
}
